import React from 'react';
import { Image } from '@udemy/react-core-components';
import { useUDData } from '@udemy/ud-data';
import { udemyBenesseLogoUrl, udemyLogoUrl } from './external/udemy-logo-urls';
import styles from "./logo.module.css";
export const Logo = ({
  ufbContext,
  showCobrandingLogo,
  ...imageProps
}) => {
  var _ufbContext$logo;
  const udData = useUDData();
  function renderMarketplaceLogo() {
    return showCobrandingLogo ? /*#__PURE__*/React.createElement(Image, Object.assign({
      src: udemyBenesseLogoUrl,
      alt: "Udemy",
      height: 28,
      width: 191
    }, imageProps)) : /*#__PURE__*/React.createElement(Image, Object.assign({
      src: udemyLogoUrl,
      alt: "Udemy",
      width: 75,
      height: 28
    }, imageProps));
  }
  if (typeof window !== 'undefined' && window.location.hostname === 'www.udemy.com') {
    return renderMarketplaceLogo();
  }
  if (udData.isGlobalMeContextLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles['logo-placeholder']
    });
  }
  return (_ufbContext$logo = ufbContext === null || ufbContext === void 0 ? void 0 : ufbContext.logo) !== null && _ufbContext$logo !== void 0 ? _ufbContext$logo : renderMarketplaceLogo();
};
//# sourceMappingURL=logo.react-component.js.map